import { isVoiceActivity } from '@/speech/capture/level';
import { BARGE_IN_LEVEL_FACTOR } from './policy';

/** Local acoustic evidence only; never confirm from a provider transcript. */
export function createAcousticOnset(voiceActivityLevel: number, now: () => number) {
  let windows = 0;
  let startedAt = 0;
  let lastAt = Number.NEGATIVE_INFINITY;
  const reset = () => {
    windows = 0;
    lastAt = Number.NEGATIVE_INFINITY;
  };
  function aboveReference(rms: number, reference: number | undefined) {
    const residual = Math.sqrt(Math.max(0, rms * rms - (reference ?? rms) ** 2));
    return (
      Number.isFinite(rms) &&
      Number.isFinite(reference) &&
      isVoiceActivity(residual, voiceActivityLevel * BARGE_IN_LEVEL_FACTOR) &&
      rms > (reference ?? Number.POSITIVE_INFINITY) * 1.35
    );
  }
  return {
    reset,
    push(rms: number, reference: number | undefined, at = now()) {
      if (!aboveReference(rms, reference)) {
        reset();
        return null;
      }
      if (at - lastAt > 80) reset();
      if (!windows) startedAt = at;
      lastAt = at;
      windows++;
      return { confirmed: windows >= 3 && at - startedAt >= 40, startedAt };
    },
  };
}
